import fetch from 'isomorphic-unfetch'

const handleErrorStatuses = async (response: Response) => {
  if (!response.ok) {
    const savedResponse = response
    const json = await response.json()
    throw new Error(
      `${savedResponse.statusText} (${savedResponse.status}) ${JSON.stringify(json)}`
    )
  }
  return response
}

export const requestWithCredentials = async (
  path: string,
  method: string = 'GET',
  data?,
  responseType: string = 'json',
  contentType: string = 'application/json'
) => {
  const options: RequestInit = {
    method,
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': contentType,
    },
  }

  if (data) {
    options.body = contentType === 'application/json' ? JSON.stringify(data) : data
  }

  const response = await fetch(path, options)
  const handledResponse = await handleErrorStatuses(response)
  const parsedResponse = handledResponse[responseType]()
  return parsedResponse
}

export default requestWithCredentials
